(function ($) {
    'use strict';

    $.mobileNav = new Object({
        selector: $('ul.lp-burger'),

        init: function () {
            var that = this;
            this.initSlicknav();
        },

        initSlicknav: function () {
            var that = this;
            this.selector.slicknav({
                prependTo: 'header#header',
                allowParentLinks: true,
                parentTag: 'span',
                wrapperTag: 'nav',
                showChildren: true,
                init: function () {},
            });
        },
    });
})(jQuery);
